import { SidebarBrand } from './SidebarBrand'
import { SidebarNav } from './SidebarNav'
import { UserCard } from './UserCard'

/**
 * Estructura visual del sidebar. El contenedor (sticky aside en desktop,
 * SheetContent en mobile) lo maneja `AuthenticatedLayout` — este componente
 * sólo se ocupa de la composición interna (brand + nav + footer del usuario).
 */
export function Sidebar() {
  return (
    <div className="flex h-full w-full flex-col bg-sidebar text-[#d1d5db]">
      <SidebarBrand />
      <SidebarNav />
      <UserCard />
    </div>
  )
}
